export default __webpack_public_path__ + "static/media/13889.conference-day-organization-committee.photo.da1eca24.jpg";